module.exports = __webpack_public_path__ + "static/media/template2.0a9af80a.png";